import {Template} from "../entities/Template";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class TemplateService extends BaseService<Template>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Template);
    }
    protected getBaseUrl():string{
        return "template";
    }
}
